import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	welcome: {
		id: 'partner.welcome.message',
		defaultMessage: 'Activate 1 Year of Calm Premium for Free',
		description: 'Welcome text',
	},
	account: {
		id: 'partner.welcome.account',
		defaultMessage:
			"Hello and welcome,{breakingLine}To begin, you'll need to log in or create a Calm account.{breakingLine}",
		description: 'Activation text',
	},
	freeAccount: {
		id: 'partner.welcome.freeAccount',
		defaultMessage: "To begin, you'll need to log in or create a personal Calm account.",
		description: 'Activation text',
	},
	logIn: {
		id: 'partner.welcome.logIn',
		defaultMessage: 'Log in',
		description: 'Text prompting the user to sign into their existing Calm account',
	},
	signUpFree: {
		id: 'partner.welcome.signUpFree',
		defaultMessage: 'Sign up for free',
		description: 'Text prompting the user to sign up for a free Calm account',
	},
	haveAccount: {
		id: 'partner.welcome.haveAccount',
		defaultMessage: 'Do you have a Calm account?',
		description: 'Have Account text',
	},
	thankYou: {
		id: 'partner.welcome.thankYou',
		defaultMessage: 'Thank you!',
		description: 'Appreciative text',
	},
	getConnected: {
		id: 'partner.welcome.getConnected',
		defaultMessage: "It's time to get you connected to Calm Business",
		description: 'Description of next steps',
	},
	termsTitle: {
		id: 'partner.welcome.dataSharing.title',
		defaultMessage: 'We value your privacy',
		description: 'A declaration of our concern for privacy',
	},
	// eslint-disable-next-line @calm/react-intl/missing-attribute
	terms: {
		id: 'partner.welcome.dataSharing.terms',
		// eslint-disable-next-line @calm/react-intl/missing-attribute
		defaultMessage: `Calm is committed to protecting and respecting your privacy. In order to access and use Calm,
        you will be asked to provide certain personal information, which Calm collects, uses, and shares to enable
        and administer the services you request in accordance with our {privacyPolicy}.  We may also share personal
        information collected through the services with {partnerName}, because {partnerName} is providing you with
        access to Calm’s product and services.  Please click 'I accept' if you consent to Calm’s collection, processing,
        storage and sharing of your personal information.  You may withdraw your consent at any time, although doing so may
        render you unable to use the service.  For more information on how to withdraw your consent, as well as our privacy
        practices generally, please review our {privacyPolicy}.{breakingLine}`,
		description: 'A description of why Calm wants to share data',
	},
	privacyPolicy: {
		id: 'partner.welcome.dataSharing.privacyPolicy',
		defaultMessage: 'Privacy Policy',
		description: 'A link to the privacy policy',
	},
	accept: {
		id: 'partner.welcome.dataSharing.accept',
		defaultMessage: 'I accept',
		description: 'Text indicating acceptance of data sharing terms',
	},
	month: {
		id: 'partner.welcome.offerDuration.month',
		defaultMessage: 'first month',
		description: 'Text indicating the one month duration for the offer',
	},
	year: {
		id: 'partner.welcome.offerDuration.year',
		defaultMessage: 'first year',
		description: 'Text indicating the first year duration for the offer',
	},
});
